import React, { useState } from "react";
import PropTypes from "prop-types";

// Config
import useTranslate from "../../hooks/useTranslate";

// Icons
import lightbulbIcon from "../../assets/icons/lightbulb-black.svg";

// Components
import CaseMediaTips from "../CaseMediaTips";
import ConfirmationDialog from "../ConfirmationDialog";

const CaseMediaWhatsNew = ({ defaultClosed }) => {
  const [closed, setClosed] = useState(defaultClosed);
  const [showTips, setShowTips] = useState(false);
  const getText = useTranslate();

  const handleCloseDialog = () => setClosed(true);
  const handleLearnHow = () => setShowTips(true);
  const handleCloseTips = () => setShowTips(false);

  return (
    <>
      <ConfirmationDialog
        open={!closed}
        onClose={handleCloseDialog}
        onConfirm={handleCloseDialog}
        onCancel={handleLearnHow}
        icon={lightbulbIcon}
        type="submit"
        title={getText("tooltips.whatsNew.title")}
        texts={[{ key: 1, text: getText("tooltips.whatsNew.description") }]}
        button={getText("common.prompts.gotIt")}
        cancel={getText("common.prompts.learnHow")}
      />
      <CaseMediaTips
        onClose={handleCloseTips}
        open={showTips}
        page="mediaPage"
      />
    </>
  );
};

CaseMediaWhatsNew.propTypes = {
  defaultClosed: PropTypes.bool.isRequired
};

export default CaseMediaWhatsNew;
